module.exports = __webpack_public_path__ + "static/media/folder.9dff6cac.svg";